/**
 * Slideshow Click Zones Override
 * Changes the hero carousel from 50/50 prev/next zones to:
 * - Left 15%: previous slide (chevron cursor)
 * - Middle 70%: click-through to slide link (pointer cursor)
 * - Right 15%: next slide (chevron cursor)
 */
(function() {
  function init() {
    var carousels = document.querySelectorAll('slideshow-carousel');
    carousels.forEach(function(carousel) {
      var customCursor = carousel.querySelector('.slideshow__cursor');
      if (!customCursor) return;

      // Override tap handler: remove old, add new with 3 zones (desktop) or full click (mobile)
      carousel.removeEventListener('tap', carousel._onSlideshowTap);
      carousel.addEventListener('tap', function(event) {
        if (event.target.matches('button, a[href], button :scope, a[href] :scope')) {
          return;
        }
        var isMobile = !window.matchMedia('screen and (pointer: fine)').matches;
        var selectedSlide = carousel.selectedSlide;
        var link = selectedSlide ? selectedSlide.querySelector('a[href]') : null;
        var slideLink = (selectedSlide && selectedSlide.tagName === 'A') ? selectedSlide.href : (link ? link.href : null);

        if (isMobile) {
          // Mobile: entire image links through
          if (slideLink) {
            window.location.href = slideLink;
          }
          return;
        }
        // Desktop: 15/70/15 zones
        var rect = carousel.getBoundingClientRect();
        var relativeX = (event.detail.originalEvent.clientX - rect.left) / rect.width;
        if (relativeX < 0.15) {
          carousel.previous();
        } else if (relativeX > 0.85) {
          carousel.next();
        } else if (slideLink) {
          window.location.href = slideLink;
        }
      });

      // Override cursor: show chevron only in 15% edge zones, pointer in middle 70%
      carousel.addEventListener('pointermove', function(event) {
        if (event.target.matches('button, a[href], button :scope, a[href] :scope')) {
          customCursor.classList.remove('is-visible', 'is-half-start', 'is-half-end');
          carousel.style.cursor = '';
          return;
        }
        var rect = carousel.getBoundingClientRect();
        var relativeX = (event.clientX - rect.left) / rect.width;
        var isOnStartZone = relativeX < 0.15;
        var isOnEndZone = relativeX > 0.85;
        var isOnMiddleZone = !isOnStartZone && !isOnEndZone;

        customCursor.classList.toggle('is-half-start', isOnStartZone);
        customCursor.classList.toggle('is-half-end', isOnEndZone);

        if (isOnMiddleZone) {
          customCursor.classList.remove('is-visible');
          carousel.style.cursor = 'pointer';
        } else {
          customCursor.classList.add('is-visible');
          carousel.style.cursor = 'none';
        }
      }, { passive: true });

      carousel.addEventListener('pointerleave', function() {
        customCursor.classList.remove('is-visible', 'is-half-start', 'is-half-end');
        carousel.style.cursor = '';
      });

      // Mobile fallback: direct click handler for touch devices
      carousel.addEventListener('click', function(event) {
        if (window.matchMedia('screen and (pointer: fine)').matches) return;
        if (event.target.matches('button, a[href], button *, a[href] *')) return;
        var selectedSlide = carousel.selectedSlide;
        var link = selectedSlide ? selectedSlide.querySelector('a[href]') : null;
        var slideLink = (selectedSlide && selectedSlide.tagName === 'A') ? selectedSlide.href : (link ? link.href : null);
        if (slideLink) {
          window.location.href = slideLink;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
